import * as echarts from 'echarts';
import React, { useEffect, useRef } from "react";
import Requestor from "../../../requestor";
import { ServeStatisticsType } from "../../../constants/dashbord"


type EChartsOption = echarts.EChartsOption;

const DashbordPage: React.FC = () => {

  const chartRef = useRef<any>(null)

  const initData = async() => {
    try {
      const res = await Requestor.getServeStatistics<ServeStatisticsType[]>()
      if (res.error !== '') {
        throw res.error
      }
      initChart(res.result || [])
      autoRefresh()
    } catch(e) {
      console.log(e);
    }
 }

  const initChart = (datas: ServeStatisticsType[]) => {
    const chartDom = document.getElementById('serve')!;
    chartRef.current = echarts.init(chartDom);
    const option: EChartsOption = {
      title: {
        text: '服务数量趋势',
        left: 'center',
        // bottom: 0
      },
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        type: 'category',
        data: datas.map((el: ServeStatisticsType) => el.date)
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: datas.map((el: ServeStatisticsType) => el.value),
          type: 'line',
        }
      ]
    };

    option && chartRef.current.setOption(option);
  }

  // 自动刷新
  let timerA: NodeJS.Timer;
  const autoRefresh = () => {
    timerA = setTimeout(() => {
      try {
        initData()
      } catch (error) {
        
      } finally {
        clearTimeout(timerA)
      }
    }, 60000)
  }

  useEffect(() => {
    initData()
    return () => {
      if (timerA) clearTimeout(timerA)
    }
  },[])

  window.addEventListener('resize', function() {
    if (chartRef) {
      chartRef.current?.resize?.()
    }
  })

  return (
    <div className='margin-top-32px margin-bottom-16px' >
      <div id="serve" style={{ width: '100%', height: 460 }}></div>
    </div>
  )
}

export default DashbordPage